import React from "react";
import UserAvatar from "../../../ui/userAvatar";
import moment from "moment";
import "./box-item.sass";

const MESSAGE_WORD_LIMIT = 16;

const truncateByWords = (message, limit) => {
  if (!message) {
    return "";
  }
  const normalized = message.replace(/\s+/g, " ").trim();
  const words = normalized.split(" ");
  if (words.length <= limit) {
    return normalized;
  }
  return `${words.slice(0, limit).join(" ")}...`;
};

const BoxItem = ({ 
  user, 
  messageInfo, 
  isActive, 
  onClick, 
  refMessages, 
  getUser, 
  refClickUser,  // ✅ Esta debe ser una función, no un ref
  setChatMobile,
  setUsersMobile,
  activeBox,
  setActiveBox
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick(user);
    }
    // ✅ FIX: Verificar que refClickUser es una función antes de llamarla
    if (refClickUser && typeof refClickUser === 'function') {
      refClickUser(user);
    }
    if (getUser) {
      getUser(user);
    }
    if (setChatMobile) {
      setChatMobile(true);
    }
    if (setUsersMobile) {
      setUsersMobile(false);
    }
    if (setActiveBox) {
      setActiveBox(user.id);
    }
  };

  return (
    <div
      className={isActive || activeBox === user?.id ? "boxItemActive" : "boxItem"}
      onClick={handleClick}
      ref={refMessages}
    >
      <div className="boxItem__user">
        <div className="boxItem__user__img">
          <UserAvatar userData={user} size="52px" />
        </div>
        <div className="boxItem__user__info">
          <p className="boxItem__user__info__name">{user?.firstName}</p>
          <p className="boxItem__user__info__message">
            {truncateByWords(messageInfo?.content, MESSAGE_WORD_LIMIT)}
          </p>
        </div>
        <div className="boxItem__user__date">
          {messageInfo?.createdAt && (
            <p className="boxItem__user__date__time">
              {moment(messageInfo.createdAt).format("HH:mm")}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default BoxItem;